import React, { useMemo } from 'react';

import { getFSRScoreRating } from '@explorer/helpers';
import { useTheme } from '@mui/material';

import { RatingScore, RatingScoreProps } from '../RatingScore';

/**
 * RatingScoreFSR
 */
export const RatingScoreFSR = ({ value, ...props }: RatingScoreFSRProps) => {
  const { palette } = useTheme();

  const overwriteColor = useMemo(() => {
    const fsr = getFSRScoreRating(value);

    return palette[fsr.riskPalette][300];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <RatingScore value={value} overwriteColor={overwriteColor} {...props} />
  );
};

/**
 * RatingScoreFSR Props
 */
export interface RatingScoreFSRProps
  extends Omit<RatingScoreProps, 'inverseColors'> {}
